import React from 'react';
import PropTypes from 'prop-types';

const RecommendationHeader = ({ iconName }) => {
	return (
		<div className="re-recommendation-header-container">
			<div className="re-recommendation-header"></div>
			<div className="re-recommendation-icon-container">
				<span className={`re-icon re-icon-${iconName}`} />
			</div>
		</div>
	);
};


RecommendationHeader.propTypes = {
	iconName: PropTypes.string.isRequired
};

export default RecommendationHeader;
